import { IRoute } from '@interfaces/routes';
import urls from '@routes/urls';
import LoginPage from '@views/LoginPage/LoginPage';
import ResourcePage from '@views/ResourcePage/ResourcePage';
import ResourcesPage from '@views/ResourcesPage/ResourcesPage';
import SharedInquiryResponsePage from '@views/SharedInquiryResponsePage/SharedInquiryResponsePage';

export const publicRoutes: IRoute[] = [
  {
    path: urls.login,
    component: LoginPage,
  },
  {
    path: urls.sharedInquiryResponse,
    component: SharedInquiryResponsePage,
  },
  {
    path: urls.category,
    component: ResourcesPage,
  },
  {
    path: urls.resource,
    component: ResourcePage,
  },
];

export default publicRoutes;
